<svelte:head>
<script src="https://cdn.jsdelivr.net/npm/toolcool-color-picker/dist/toolcool-color-picker.min.js"></script>
</svelte:head>
<script>
	import { onMount } from 'svelte';
	import { createEventDispatcher } from 'svelte';
	export let color;
	export let label;
	
	let refColorPicker;

	onMount(() => {
		// 라이브러리 로딩 후 초기화 작업이 필요한 경우
		if (refColorPicker) {
			refColorPicker.color = color;  // 수동으로 색상 업데이트
		}
	});
  
	// 색상 변경 시 부모에게 알리기
	const handleColorChange = () => {
		if (refColorPicker) {
		const selectedColor = refColorPicker.color;
		// 부모로 색상 변경 알리기
		dispatch('colorChange', selectedColor);
		}
	};

	const dispatch = createEventDispatcher();
</script>

<div
  class="cbc-row tw-relative tw-flex tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-border tw-bg-muted/30 tw-px-3 tw-py-2 tw-font-sans"
>
  <toolcool-color-picker
    class="color-target"
    bind:this={refColorPicker}
    color={color}
    button-width="3.5rem"
    button-height="2rem"
    button-padding="2px"
    on:change={handleColorChange}
  />
  <div class="tw-text-sm tw-font-medium tw-text-foreground">{label}</div>
</div>

<style>
  /* 색상 팝업이 옆/아래 요소에 가리지 않도록 위로 쌓기 */
  .cbc-row {
    z-index: 30;
  }
  /* 피커를 열면(포커스) 그 행을 다른 피커 행보다 위로 올림 → 팝업이 아래 피커에 안 가림 */
  .cbc-row:focus-within {
    z-index: 60;
  }
  .cbc-row :global(toolcool-color-picker) {
    position: relative;
    z-index: 40;
  }
</style>